<style scoped>
    div {
        height: 100%;
    }

    img {
        max-height: 330px;
        transition: all 200ms ease-in-out;
    }

    .carousel {
        margin-top: -30px;
    }

    span {
        font-size: 30px;
    }
</style>
<template>
    <el-dialog title="图片预览" :visible.sync="showTag" width="60%" append-to-body>
        <el-carousel class="carousel" :autoplay="false" height="330px" arrow="always" :initial-index="index"
                     indicator-position="none"
                     ref="carousel" @change="change">
            <el-carousel-item v-for="(item,index) in list" :key="index">
                <div class="flex aic jcc" style="overflow: auto">
                    <img class="flex0" :src="item" alt="" :style="style">
                </div>
            </el-carousel-item>
        </el-carousel>
        <div class="flex aic jcc pt15">
            <span v-for="(m,index) in map" class="iconfont pointer" :class="[m.icon,{ml30:index>0}]"
                  @click="handler(m.id)"></span>
        </div>
    </el-dialog>
</template>

<script>
  const map = [
    {name: '左转', icon: 'icon-zuozhuan-', id: 'zuo'},
    {name: '右转', icon: 'icon-youzhuan-', id: 'you'},
    {name: '放大', icon: 'icon-fangda', id: 'da'},
    {name: '缩小', icon: 'icon-minus', id: 'xiao'},
  ];


  export default {
    name: "pic-scan",
    props: {},
    data() {
      return {
        map,
        deg: 0,
        scale: [1, 1],
        index: 0,
        list: [],
        showTag: false
      }
    },
    computed: {
      style() {
        const [sx, sy] = this.scale;
        return {
          transform: `rotate(${this.deg}deg) scale(${sx},${sy})`
        }
      }
    },
    methods: {
      change(index) {
        this.index = index;
        this.deg = 0;
        this.setScale(1, 1);
      },

      setScale(x, y) {
        this.$set(this.scale, 0, x);
        this.$set(this.scale, 1, y);
      },

      handler(type) {
        let [x, y] = this.scale;
        switch (type) {
          case 'zuo':
            this.deg += 90;
            break;
          case 'you':
            this.deg -= 90;
            break;
          case 'da':
            this.setScale(x + 0.2, y + 0.2);
            break;
          case 'xiao':
            this.setScale(x - 0.2, y - 0.2);
            break;
        }
      },
      show(index, list) {
        this.index = index;
        this.list = list;
        this.showTag = true;
        this.$nextTick(() => {
          this.$refs.carousel.setActiveItem(index);
        });
      },
      hide() {
        this.showTag = false;
      }
    },
  }
</script>
